var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/wkappstore/viewmodels/index',["require", "exports", "common/viewmodelbase", "models/portal"], function (require, exports, Common, Portal) {
    "use strict";
    var WKAppStoreViewModel = (function (_super) {
        __extends(WKAppStoreViewModel, _super);
        function WKAppStoreViewModel() {
            _super.call(this);
            this.mobileApps = [];
            this.breadCrumb = new Portal.ModuleBreadCrumbItemHolder();
            this.title = "WKAppStore";
            //ko.track(this, [""]);
        }
        WKAppStoreViewModel.prototype.onActivated = function (context) {
            this._symbol = {
                config: "",
                fragment: "tools",
                params: null,
                queryParams: null,
                queryString: null
            };
            this._currentNode = Portal.Context.shell.findNodeFor(this._symbol);
            this.getWKAppStoreTiles();
            if (this.breadCrumb.items.length === 0) {
                var crumb = Portal.BreadCrumbItem.from("WKAppStore");
                this.breadCrumb.items.push(crumb);
            }
        };
        //private getWKAppStoreTiles(): void {
        //	this.navigationTree = Portal.Context.shell.rawNavigation;
        //	for (var i = 0; i < this.navigationTree.children.length; i++) {
        //		if (this.navigationTree.children[i].groupId === this.title) {
        //			this.mobileApps.push(this.navigationTree.children[i]);
        //		}
        //	}
        //}
        WKAppStoreViewModel.prototype.getWKAppStoreTiles = function () {
            var _this = this;
            if (this._currentNode.children != null) {
                var items = Enumerable.From(this._currentNode.children)
                    .Where(function (n) { return n.groupId === _this.title; });
                this.mobileApps = items.ToArray();
            }
        };
        WKAppStoreViewModel.prototype.navigate = function (symbol) {
            Portal.Context.shell.navigateTo(symbol);
        };
        return WKAppStoreViewModel;
    }(Common.ViewModelBase));
    var instance = new WKAppStoreViewModel();
    return instance;
});

